import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { visualizerActions,uiActions } from '../../store';

export default function useCompare() {
    const dispatch = useDispatch();
    const compareData = useSelector(state => state.visualizer.compareData);

    const containerRef = useRef(null);
    const afterWrapperRef = useRef(null);
    const sliderRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!isDragging) return;
            if (!containerRef.current || !afterWrapperRef.current || !sliderRef.current) return;

            const rect = containerRef.current.getBoundingClientRect();
            let offsetX = e.clientX - rect.left;
            offsetX = Math.max(0, Math.min(offsetX, rect.width));
            const percent = (offsetX / rect.width) * 100;

            afterWrapperRef.current.style.width = `${percent}%`;
            sliderRef.current.style.left = `${percent}%`;
        };

        const handleMouseUp = () => setIsDragging(false);

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isDragging]);

    //Keep chamVizSub image width matched to chamViz image width
    useEffect(() => {
        const updateChamVizSubWidth = () => {
            const chamViz = document.getElementById('chamViz');
            const chamVizSub = document.getElementById('chamVizSub');

            if (!chamViz || !chamVizSub) return;

            const chamVizImg = chamViz.querySelector('img.viz');
            const chamVizSubImg = chamVizSub.querySelector('img.viz');

            if (chamVizImg && chamVizSubImg) {
                chamVizSubImg.style.width = `${chamVizImg.offsetWidth}px`;
                chamVizSubImg.style.height = `${chamVizImg.offsetHeight}px`;
            }
        };

        // Initial match
        updateChamVizSubWidth();

        // Listen to window resize
        window.addEventListener('resize', updateChamVizSubWidth);

        return () => {
            window.removeEventListener('resize', updateChamVizSubWidth);
        };
    }, []);

    const handleCompareToggle = () => {
        const chamVizSub = document.getElementById('chamVizSub');

        if (!compareData.active) {
            const vizData = document.getElementById('chamViz').getSaveData();
            chamVizSub.load(vizData.spec, '-1');
            Object.assign(chamVizSub.style, { zIndex: '5', visibility: 'visible' });
        } else {
            chamVizSub.style.visibility = 'hidden';
        }

        dispatch(visualizerActions.setCompareData({ key: 'active', value: !compareData.active }));
    };

    const handleCompareSideChange = (side) => {
        dispatch(visualizerActions.setCompareData({ key: 'side', value: side }));
    };

    const applyCompareSide = (side) => {
        const chamVizSub = document.getElementById('chamVizSub');
        chamVizSub.style.visibility = 'hidden';

        dispatch(visualizerActions.setCompareData({ key: 'active', value: false }));

        const vizData = document.getElementById(side).getSaveData();

        //only reload if it's not the main viz.
        if(side != 'chamViz'){
            dispatch(uiActions.setVizLoading(true));
            document.getElementById('chamViz').load(vizData.spec, vizData.sel);
        }
 
            
    };

    return {
        containerRef,
        afterWrapperRef,
        sliderRef,
        setIsDragging,
        handleCompareToggle,
        handleCompareSideChange,
        applyCompareSide,
    };
}
